import styled from 'styled-components';

import FlexColToRow from '@ui/molecules/FlexColToRow';

import theme from '@theme/FolxTheme';

export const DashboardInfoDisplay = styled(FlexColToRow).attrs({
	breakpoint: 'tablet',
})`
	position: relative;
	justify-content: space-between;
	padding: ${theme.spacing.md};
	gap: ${theme.spacing.smmd};
	width: 100%;
	min-height: 14.8rem;
`;
